<template>
  <div id="serviceAgreementPage">
    <main class="contentModule">
      <header>{{header}}</header>
      <div class="policyNumber">协议/保障号：<span class="param">{{accode}}</span></div>
      <div v-if="!this.$$.isValidObj(preview)" class="policyNumber">绑定手机号：<span class="param">{{phoneNum}}</span></div>
      <div style="text-indent: 25px;">
        欢迎加入米兔科技手机碎屏<b>保障计划</b>。请<b>您</b>务必仔细阅读此<b>服务协议</b>条款尤其是以下划线标注的文字内容。如<b>您</b>已选购该<b>保障计划</b>或<b>我司</b>已受理您的报修申请的，视为<b>您</b>完全同意该<b>服务协议</b>条款。
      </div>
      <section>
        <div class="section-titles">>>>定义</div>
        <p><b>我司：</b><span>指根据本协议承担责任的公司，即：广州米兔科技网络有限公司。</span></p>
        <p><b>保障计划：</b><span>指本手机碎屏保障计划。</span></p>
        <p><b>服务协议：</b><span>指本手机碎屏保障计划服务协议条款。</span></p>
        <p><b>您/用户：</b><span>指在联通或联通授权渠道购买手机和本<b>保障计划</b>的个人。</span></p>
        <p><b>IMEI码：</b><span>IMEI(International Mobile Equipment Identity)是国际移动设备身份码的缩写，即通常所说的手机序列号或手机串号，用于在移动电话网络中识别每一部独立的手机等行动通讯装置，相当于移动电话的身份证。</span></p>
        <p><b>神秘失踪：</b><span>指<b>用户</b>通知损失时无法举证被保障设备遗失的时间、地点和原因。</span></p>
        <p><b>抢劫：</b><span>指以非法占有为目的，对<b>用户</b>当场使用暴力、胁迫或其他方法，强行将<b>用户</b>财物抢走的行为。</span></p>
        <p><b>盗窃：</b><span>指有明显现场痕迹的他人非法盗取或试图盗取<b>用户</b>财产的行为。</span></p>
      </section>
      <section>
        <div class="section-titles">>>>协议条款</div>
        <div>
          <div class="series-titles">一、服务保障对象</div>
          <p>本<b>保障计划</b>的保障对象为<b>您</b>在联通或联通授权的线上平台或线下门店购买的，仅限于个人或家庭使用的全新手机。</p>
        </div>
        <div>
          <div class="series-titles">二、服务保障范围</div>
          <p><b>1、在服务有效期内，您的手机因意外坠落、碰撞、挤压造成的屏幕组件碎裂或产生裂纹，可免费更换一次原装屏幕组件/或严选屏幕。</b></p>
          <p>2、在服务期限内<b>我司或我司合作服务商</b>仅提供一次服务，即完成一次维修或更换手机服务后<b>我司</b>的义务履行完毕，本协议立即终止。</p>
          <p>3、<b>我司</b>不提供任何形式的现金或现金等价物赔偿。</p>
        </div>
        <div>
          <div class="series-titles">三、服务保障期限</div>
          <p>
            <span>选购本保障服务后，自您登陆指定网站成功激活/领取次日零时起生效，有限期为1年。</span>
            <b>本服务协议有效期为：</b>
            <span class="validTime"><span class="param">{{startTime}} </span>至<span class="param"> {{endTime}} </span>止。</span>
          </p>
        </div>
        <div>
          <div class="series-titles">四、服务流程</div>
          <p>在<b>您</b>购买了新机和本<b>保障计划</b>后，请妥善保管手机的发票、联通权益服务购买发票（如有）以及手机的原包装盒。</p>
          <p>（一）在服务期限内，因意外坠落、碰撞、挤压造成的屏幕组件碎裂或产生裂纹，请您立即拨打24小时服务电话400-609-5509进行报案或报修，否则我司将无法为您提供服务；如需协助或对服务质量的建议，请拨打电话020-8251 3114。</p>
          <p>（二）如果您的报修请求属于本保障计划的服务范围，<b>我司</b>的客服人员将为您提供服务指引，您需要将损坏手机送修。若您不方便前往指定维修点的，也可以采取寄修的方式。</p>
          <p>（三）根据您寄送或到店送修的选择安排对应维修商；手机寄送给或到店送达维修商后，维修商对寄送/到店的实物进行复核。如实物审核通过，维修商对实物进行维修修复后，当场交付或寄送给您。</p>
          <p>（四）因维修更换所产生的旧零部件及旧机的所有权归我司所有。</p>
          <p>（五）<b>我司</b>承诺使用原装屏幕组件/或严选屏幕。</p>
        </div>
        <div>
          <div class="series-titles">五、下列任一情形下发生的损失、费用不属于本保障计划保障范围</div>
          <div class="unit-titles">第一部分  与设备损坏有关的责任免除：</div>
            <p>1、不属于服务合同中约定范围内的故障或问题造成的损失；</p>
            <p>2、非由被保险人、其授权服务提供商或其代理人所提供的维修或置换服务；</p>
            <p>3、被保障设备出厂时未经检验或经检验属于不合格；</p>
            <p>4、经国家质量技术监督检验机构或任何专业技术机构鉴定，被保障设备存在由于设计、制造等方面的原因而在某一批次、型号或类别的被保障设备中普遍存在的具有同一性的质量问题；</p>
            <p>5、无论何种原因、何时授权，由生产商、经销商或其他任何个人或法人在任何时候自愿或非自愿实施的设备召回；</p>
            <p>6、被保障设备在使用过程中所产生的不影响其使用性能的磨损或损耗，以及更换超过合理使用寿命的易损、易耗零部件所产生的费用；</p>
          <div class="unit-titles">第二部分 与设备灭失有关的责任免除：</div>
            <p>7、设备神秘失踪；</p>
          <div class="unit-titles">第三部分  通用责任免除</div>
            <p>8、消费者无法提供有效的服务合同和被保障设备的购买发票；</p>
            <p>9、被保障设备无法确定出厂日期或销售日期；</p>
            <p>10、在服务合同中记载的设备型号、设备身份标识等相关信息与实际损失的设备不符或经涂改；</p>
            <p>11、消费者/设备持有者、生产商、经销商、维修服务商或前述机构的任何董事、高级管理人员、雇员、代理人、独立承包商的任何欺诈、不诚实或犯罪行为、故意行为；</p>
            <p>12、任何性质的间接损失，包括但不限于利润损失、有关服务标准的赔偿、消费者的时间损失、话费损失、非设备的基本功能所需的数据、程序、软件的丢失和损坏及精神损害赔偿等等；</p>
            <p>13、消费者/设备持有者提供接通服务、呼叫服务或其他非服务合同中所约定的服务所发生的费用；</p>
            <p>14、被保障设备导致消费者或其他人遭受人身伤害和财产损失；</p>
            <p>15、消费者/设备持有者与消费者、生产商、经销商、维修服务商之间的任何诉讼、仲裁以及律师费用；</p>
            <p>16、战争、敌对行为、军事行动、武装冲突、恐怖活动、罢工、暴动或暴乱、民众骚乱、行政或执法行为；</p>
            <p>17、核爆炸、核裂变、核聚变，放射性污染及其他各种环境污染；</p>
            <p>18、不可抗力、行政行为、司法行为；</p>
            <p>19、罚款、罚金及惩罚性赔偿； 对于任何可能导致本公司或服务合作商违反联合国经济贸易制裁决议或违反欧盟、英国、美国、中国关于制裁、禁运或限制相关法律法规的风险，本公司在任何情况下均不提供保障亦不承担保障赔偿责任；</p>
            <p>20、任何法律规定不可保障的损失。</p>
        </div>
        <div>
          <div class="series-titles">六、退换货与转让</div>
          <p>1、用户加入本保障计划的，在所购手机交易成功之时7天内如发生退货，则退货后本保障计划即自动失效；</p>
          <p>2、本保障计划在生效7天后、或未发生退货、或接受我司的服务后，我司不再接受因任何原因导致的本保障计划的转让或撤销。</p>
        </div>
        <div>
          <div class="series-titles">七、保障计划的终止</div>
          <p>有下列情形之一的，本<b>保障计划</b>自然终止:</p>
          <p>1、已达到<b>服务协议</b>约定的服务期限的；</p>
          <p>2、<b>您</b>已将手机出售或转让给他人；</p>
          <p>3、<b>您</b>的手机经非由<b>我司</b>或该品牌手机厂家授权的其他修理人进行修理或置换的；</p>
          <p>4、<b>我司</b>为该手机已提供了一次维修服务，即被视为<b>我司</b>已经完全履行本<b>服务协议</b>的义务。</p>
          <p>5、<b>您</b>存在故意损坏或欺诈行为。</p>

        </div>
      </section>
      <footer>
        服务咨询及监督：<a href="tel:02082513114" >020-8251 3114</a>（服务时间为每天09:30至18:00）
      </footer>
    </main>
  </div>
</template>

<script>
    export default {
      name: "serviceAgreementPage",
      data() {
        return {
          header: '手机碎屏保障计划服务协议',
          accode: '*********',
          startTime: '****年*月*日',
          endTime: '****年*月*日',
          phoneNum: '***********',
          rightsToken: null,
          preview: null,
        }
      },
      methods: {
        getAgreementInfo(){
          let that = this;
          let loading = that.Loading.service({fullscreen: true});
          that.axios.post('/management/unicom/getAgreementInfo', {rightsToken: that.rightsToken}).then((response) => {
            that.$nextTick(() => loading.close());
            let data = response.data;

            if (data.success) {
              const {accode, phoneNum, startTime, endTime} = data.datas;
              if (that.$$.isValidObj(accode)) that.accode = accode;
              if (that.$$.isValidObj(phoneNum)) that.phoneNum = phoneNum;
              that.startTime = startTime;
              that.endTime = endTime;
            }else {
              that.$message.error(data.msg);
            }
          });
        },

      },
      mounted() {
        let that = this;
        that.rightsToken = decodeURIComponent(encodeURIComponent(that.$route.query.rightsToken).replace('%20', '%2B'));
        that.preview = that.$route.query.preview;

        //-- 获取权益数据
        if (that.$$.isValidObj(that.rightsToken)) {
          that.getAgreementInfo();
        }else if (that.$$.isValidObj(that.preview)){
          that.accode = '（以实际为准）';
          $('.validTime').html('（以实际为准）').css({'font-weight':'bold', 'color':'#ff7052'});
        }else {
          that.header += '模板';
        }
      }
    }
</script>

<style scoped>
  #serviceAgreementPage{
    width: 100%;
    height: 100%;
    padding: .75rem;
  }

  .contentModule{
    padding: 1rem;
    box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.3);
    letter-spacing: 1px;
  }
  .contentModule header{
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }
  .contentModule div{
    line-height: 22px;
  }

  .section-titles{
    font-weight: bold;
    font-size: 16px;
    line-height: 50px!important;
  }

  .series-titles{
    font-weight: bold;
    font-size: 16px;
    color: #0070c0;
    line-height: 40px!important;
  }

  .unit-titles{
    font-weight: bold;
    font-size: 14px;
    line-height: 40px!important;
  }

  .policyNumber{
    text-align: right;
    font-weight: bold;
    font-size: 14px;
    margin: 10px 0 10px;
  }

  .param{
    color: #ff7052;
  }

  footer{
    margin: 30px 0 4px;
    font-size: 14px;
    color: #ff7052;
  }
  footer a{
    display: inline-block;
    color: #ff7052;
    border-bottom: 1px solid #ff7052;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/serviceAgreementPage.vue